import { useCallback, useMemo } from "react";
import { StatusCell, UserRolesCell } from "..";
import { RoleCell } from "pages/School/AffiliationManagement";
import { CopyItemCell, tableHooks } from "components/Table";
import { useNavigate } from "react-router-dom";
import { app } from "router/routes";

const useColumns = () => {
    const navigate = useNavigate()

    const editUser = useCallback(({ id }) => {
        navigate(`${app.users}/${id}`)
    }, [])

    const editCell = tableHooks.useEditCell({
        action: editUser,
        feature: "user_role",
        role: "edit"
    })

    const usersColumns = useMemo(() => [{
        accessorKey: "id",
        header: "ID"
    },
    {
        accessorKey: "first_name",
        header: "שם",
        cell: ({ row }) => row.original.full_name
    },
    {
        accessorKey: "username",
        header: "שם משתמש",
        cell: CopyItemCell,
        meta: {
            tooltip: "שם משתמש הועתק בהצלחה"
        },
    },
    {
        accessorKey: "initial_pass",
        header: "סיסמא",
        enableSorting: false,
        cell: CopyItemCell,
        meta: {
            tooltip: "סיסמא הועתקה בהצלחה"
        }
    },
    {
        accessorKey: "email",
        header: "כתובת מייל",
        cell: CopyItemCell,
        meta: {
            tooltip: "כתובת המייל הועתקה בהצלחה"
        }
    },
    {
        accessorKey: "phone_number",
        header: "מספר טלפון",
        enableSorting: false
    },
    {
        accessorKey: "tz",
        header: "תעודת זהות",
        enableSorting: false
    },
    {
        accessorKey: "status",
        header: "סטטוס",
        enableSorting: false,
        cell: StatusCell
    },
        editCell
    ], [])

    const userColumns = useMemo(() => [
        {
            accessorKey: "affiliation_name",
            header: "בית ספר",
            enableSorting: false
        },
        {
            accessorKey: 'role',
            header: "תפקיד",
            cell: ({ getValue }) => <RoleCell role={getValue()} />,
            enableSorting: false
        },
        {
            accessorKey: 'user_data',
            header: "שיוך",
            cell: UserRolesCell,
            enableSorting: false
        }
    ], [])

    return {
        usersColumns,
        userColumns
    }
}

export default useColumns